const prediggoTranslation = {
  'cultureType': 'visa-bara',
  'cultureType/Bio': 'visa-bara/eko',
  'cultureType/Sans%20r%E9sidu%20de%20pesticide': 'visa-bara/inga-pesticidrester',
  'cultureType/Sans%20OGM': 'visa-bara/gmo-fri',
};

export default prediggoTranslation;
